import "./GrandstreamCentral.module.css";
import Header from "@/reusable_sections/Header";
import Catalogshowcase from "./sections/Catalogshowcase";
import Brandannouncement from "./sections/Brandannouncement";
import AvStreamConnectHero from "./sections/AvStreamConnectHero";
import HybridConnectivityBenefits from "./sections/HybridConnectivityBenefits";
import AvStreamTiersComparison from "./sections/AvStreamTiersComparison";
import TechnicalCapabilities from "./sections/TechnicalCapabilities";
import CloudHybridArchitecture from "./sections/CloudHybridArchitecture";
import CtaContact from "./sections/CtaContact";
import Footer from "@/reusable_sections/Footer";
export default function GrandstreamCentralPage() {
  return <div>
      <Header />
      <Catalogshowcase />
      <Brandannouncement />
      <AvStreamConnectHero />
      <HybridConnectivityBenefits />
      <AvStreamTiersComparison />
      <TechnicalCapabilities />
      <CloudHybridArchitecture />
      <CtaContact />
      <Footer />
    </div>;
}